import { Link } from "react-router-dom";

function CourseOverview({ course, topics = [], testSeries = [] }) {
  const topicTests = topics.flatMap((topic) =>
    topic.tests.map((test) => ({
      ...test,
      kind: "topic",
      context: topic.name,
    }))
  );
  const seriesTests = testSeries.flatMap((series) =>
    series.tests.map((test) => ({
      ...test,
      kind: "series",
      context: series.title,
    }))
  );
  const attempted = [...topicTests, ...seriesTests]
    .filter((test) => test.attempt)
    .sort((a, b) => (b.attempt.id || 0) - (a.attempt.id || 0));

  const stats = [
    course.courseType === "topic-wise" ? { label: "Topics", value: topics.length } : null,
    {
      label: "Tests",
      value: course.courseType === "topic-wise" ? topicTests.length : seriesTests.length,
    },
    { label: "Full length series", value: testSeries.length },
    { label: "Attempted", value: attempted.length },
  ].filter(Boolean);

  return (
    <div className="course-overview">
      <h2>{course.title}</h2>
      <p className="course-overview-copy">
        {course.description || "No description for this course yet."}
      </p>
      <div className="overview-stats">
        {stats.map((stat) => (
          <article key={stat.label}>
            <span>{stat.label}</span>
            <strong>{stat.value}</strong>
          </article>
        ))}
      </div>

      <h3>Your test analysis</h3>
      {attempted.length === 0 ? (
        <p>You have not attempted a test in this course yet.</p>
      ) : (
        <>
          <p>
            {attempted.length === 1
              ? "1 test attempted."
              : `${attempted.length} tests attempted.`}
          </p>
          <div className="recent-attempts">
            {attempted.slice(0, 5).map((test) => (
              <article key={`${test.kind}-${test.id}`}>
                <div>
                  <p className="learn-kicker">{test.context}</p>
                  <h3>{test.title}</h3>
                  <p>
                    Score {test.attempt.marks} · +{test.attempt.positive} / -{test.attempt.negative}
                  </p>
                </div>
                <Link
                  className="test-action-secondary"
                  to={`/my-courses/${course.id}/tests/${test.kind}/${test.id}/analysis`}
                >
                  Analysis
                </Link>
              </article>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default CourseOverview;
